import apiService from '../apiService';

const SUPER_ADMIN_URL = '/super-admin'

const authService = {
  /** Fresh 2FA rule and state (OL-157); the stored user only has the sign-in copy. */
  async securityStatus() {
    try {
      const response = await apiService.get('/auth/security-status');
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  // Super Admin
  async superAdminlogin(credentials) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/auth/login`, credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async superAdminlogout() {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/auth/logout`);
      return response;

    } catch (error) {
      throw error;
    }
  },

  async superAdminEnable2fa() {
    try {
      const response = await apiService.get(`${SUPER_ADMIN_URL}/2fa/enable`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminVerify2faOTP(otp) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/2fa/enable-verify`, otp);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminDisableVerify2faOTP(otp) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/2fa/disable`, otp);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  async superAdminVerify2faLoginOTP(payload) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/2fa/verify`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },



  // Tenenat
  async login(credentials) {
    try {
      const response = await apiService.post('/auth/login', credentials);
      return response.data;
    } catch (error) {
      throw error;
      // throw error.response.data;
    }
  },

  async logout() {

    try {
      const response = await apiService.post('/auth/logout');
      return response;

    } catch (error) {
      throw error;
    }
  },

  async forgotPassword(credentials) {
    try {
      const response = await apiService.post('/auth/forgot-password', credentials);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // The "Set your password" link in a welcome email (OL-222).
  async setWelcomePassword(payload) {
    try {
      const response = await apiService.post('/auth/set-password', payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetPassword(credentials) {
    try {
      const response = await apiService.post('/auth/reset-password', credentials);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async resendVerificationEmail() {
    try {
      const response = await apiService.post('/auth/reset-password');
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async enable2fa() {
    try {
      const response = await apiService.get('/auth/2fa/enable');
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async verify2faOTP(otp) {
    try {
      const response = await apiService.post('/auth/2fa/enable-verify', otp);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async disableVerify2faOTP(otp) {
    try {
      const response = await apiService.post('/auth/2fa/disable', otp);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  async verify2faLoginOTP(payload) {
    try {
      const response = await apiService.post('/auth/2fa/verify', payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },


  async deleteAllSession() {
    try {
      const response = await apiService.delete('/auth/auth/user-sessions/delete');
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async verifyOTP(credentials) {
    try {
      const response = await apiService.post('/auth/verify-otp', credentials);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default authService;